import { Fragment, useState } from 'react'
import Progress7DaysChart from './Graph/Progress7DaysChart'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'

const Issue: React.FC = () => {
  const { projectData, downloadDailyReport } = useProjectStore(
    state => ({
      projectData: state.selected,
      downloadDailyReport: state.downloadDailyReportByProjetId,
    }),
    shallow
  )

  const [isDownloadDailyReport, setIsDownloadDailyReport] = useState(false)

  const onDownloadDailyReport = () => {
    console.log('projectData', projectData)
    setIsDownloadDailyReport(true)
    downloadDailyReport(projectData?.id).then(({ data, success }) => {
      if (!success) {
        toast.error(data)
      }
      setIsDownloadDailyReport(false)
    })
  }

  return (
    <Fragment>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title'></div>
          <div className='card-toolbar'>
            <button
              className='btn btn-sm btn-primary me-3'
              onClick={onDownloadDailyReport}
              disabled={isDownloadDailyReport}>
              {isDownloadDailyReport ? 'กำลังดาวน์โหลด...' : 'ดาวน์โหลดรายงานประจำวัน'}
            </button>
          </div>
        </div>
        <div className='card-body'>
          <div className='row gy-5'>
            <div className='col-12'>
              <Progress7DaysChart />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default Issue
